import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AddressModel } from '../../models/address.model';

@Component({
	selector: 'address-selection-input',
	templateUrl: './address-selection-input.component.html',
	styleUrls: ['./address-selection-input.component.scss'],
})
export class AddressSelectionInputComponent implements OnInit, AfterViewInit {
	@Input() source: string;
	@Input() addressType: string;
	@Input() placeholder: string = 'Enter a location';
	@Output() selectAddress: EventEmitter<any> = new EventEmitter<any>();
	@ViewChild('addresstext') addresstext: any;

	@Input() autocompleteInput: string;
	@Output() autoCompleteInputChange = new EventEmitter<string>();

	//autocompleteInput: string;
	addressObject: AddressModel = new AddressModel();

	existingAddressValue: boolean = false;

	queryWait: boolean;

	constructor() {}

	ngOnInit(): void {
		this.existingAddressValue = this.autocompleteInput ? true : false;
	}

	ngAfterViewInit() {
		if (!this.existingAddressValue) {
			this.getPlaceAutocomplete();
		}
	}

	private getPlaceAutocomplete() {
		const autocomplete = new google.maps.places.Autocomplete(this.addresstext.nativeElement, {
			componentRestrictions: { country: 'US' },
			types: ['geocode'], // 'establishment' / 'address' / 'geocode'
		});
		google.maps.event.addListener(autocomplete, 'place_changed', () => {
			const place = autocomplete.getPlace();
			this.invokeEvent(place);
		});
	}

	invokeEvent(place: any) {
		let street;
		let route;
		for (let addComp of place.address_components) {
			if (addComp.types.includes('street_number')) {
				street = addComp.short_name;
			}
			if (addComp.types.includes('route')) {
				route = addComp.short_name;
			}
			if (addComp.types.includes('locality')) {
				this.addressObject.city = addComp.short_name;
			}
			if (addComp.types.includes('administrative_area_level_1')) {
				this.addressObject.state = addComp.short_name;
			}
			if (addComp.types.includes('postal_code')) {
				this.addressObject.zipCode = addComp.short_name;
			}
		}
		this.addressObject.street = `${street} ${route}`;
		this.addressObject.latitude = place.geometry.location.lat();
		this.addressObject.longitude = place.geometry.location.lng();
		this.addressObject.formattedAddress = place.formatted_address;
		this.selectAddress.emit(this.addressObject);
	}

	resetAutoComplete() {
		this.autocompleteInput = undefined;
		this.selectAddress.emit(new AddressModel());
		this.getPlaceAutocomplete();
	}
}
